import { isRack, Rack, stagingBay } from "src/services/item/rack.interface";
import { BaseLocation } from "src/services/subscription/base-locations.enum";
import { DimensionUnit, WeightUnit } from "src/services/item/item.interface";

export function getCityOptions(): string[] {
  return [BaseLocation.parkCity, BaseLocation.vail];
}

export function getBayOptions(): string[] {
  return [stagingBay, "1", "2", "3", "4", "5", "6", "7"];
}

export function getRowOptions(): string[] {
  return ["A", "B", "C", "D"];
}

export function getDimensionUnitOptions(): DimensionUnit[] {
  return ["cm", "in"];
}

export function getWeightUnitOptions(): WeightUnit[] {
  return ["kg", "lbs"];
}

export function getNumberOptions(): string[] {
  return [...Array(55 + 1).keys()].slice(1).map((number) => number.toString());
}

export function isValidRack(rack: Rack): boolean {
  if (!rack || !isRack(rack)) {
    return false;
  }

  if (!getBayOptions().includes(rack.bay)) {
    return false;
  }

  if (!getRowOptions().includes(rack.row)) {
    return false;
  }

  return getNumberOptions().includes(rack.number);
}
